import React, { useContext } from 'react';
import FilterPlates from './FilterPlates';
import FilterPlatesContext from '../../contexts/FilterPlatesContext';

const FilterPlatesContainer = ({
  isScope,
  isReport,
  isDashboardCard,
  onManualFilterChanged,
  onFilterAdded,
  onFilterRemoved,
  testIdPrefix,
  label,
  hideInheritedFilters,
  isEveryFilterInteractive,
  hideAddFilterButton,
  hiddenDrillDownIds,
  leadingChildren,
  children,
}: {
  isScope?: boolean;
  isReport?: boolean;
  isDashboardCard?: boolean;
  onManualFilterChanged?: () => void;
  onFilterAdded?: () => void;
  onFilterRemoved?: () => void;
  testIdPrefix?: string;
  label?: string;
  hideInheritedFilters?: boolean;
  isEveryFilterInteractive?: boolean;
  hideAddFilterButton?: boolean;
  hiddenDrillDownIds?: string[];
  leadingChildren?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  const { drillDowns, scope } = useContext(FilterPlatesContext);

  return (
    <FilterPlates
      drillDowns={drillDowns}
      scope={scope}
      isScope={!!isScope}
      isReport={isReport}
      isDashboardCard={isDashboardCard}
      onManualFilterChanged={onManualFilterChanged}
      onFilterAdded={onFilterAdded}
      onFilterRemoved={onFilterRemoved}
      testIdPrefix={testIdPrefix}
      label={label}
      hideInheritedFilters={hideInheritedFilters}
      isEveryFilterInteractive={isEveryFilterInteractive}
      hideAddFilterButton={hideAddFilterButton}
      hiddenDrillDownIds={hiddenDrillDownIds}
      leadingChildren={leadingChildren}
    >
      {children}
    </FilterPlates>
  );
};

export default FilterPlatesContainer;
